module.exports = __webpack_public_path__ + "static/media/auditorium.11d9d8ee.glb";